import React from 'react'
import CategoryTitle from '../../CategoryTitle'
import Cta from '../../Cta'
import SimpleBlockContent from '../../SimpleBlockContent'
import styles from './styles.module.css'
import { PALETTE } from '../../../styles/constants'
import SideImage from './SideImage'
import SideTextBlocks from './SideTextBlocks'

const cx = (...c) => c.filter(Boolean).join(' ')

function TextAndSideImage({ sideImage, sideTextBlocks, theme, category, textColor = { value: PALETTE.white }, title, text, reversed, cover, extraPaddingBottom, ctas }) {
  const sideImageOverridden = sideTextBlocks && sideTextBlocks.length

  return (
    <div
      className={cx(styles.wrapper, extraPaddingBottom && styles.wrapperExtraPaddingBottom)}
      style={{ backgroundColor: theme.value, color: textColor.value }}
    >
      <div className={cx(styles.contentWrapper, sideImageOverridden && styles.contentWrapperSideImageOverridden)}>
        {
          sideImageOverridden ?
            <SideTextBlocks textBlocks={sideTextBlocks}/> :
            <SideImage sideImage={sideImage} cover={cover}/>
        }
        <div className={cx(
          styles.textAndCtasWrapper,
          reversed && styles.textAndCtasWrapperReversed,
          sideImageOverridden && styles.textAndCtasWrapperSideImageOverridden
        )}>
          {category && category.title.length > 0 && <CategoryTitle color={category.color.value}>{category.title}</CategoryTitle>}
          <div className={styles.title}>
            <SimpleBlockContent blocks={title} noSpace />
          </div>
          <div className={styles.textBlock}>
            {text && <SimpleBlockContent blocks={text} />}
          </div>
          {ctas && (
            <div className={styles.ctas}>
              {ctas.map((cta) => (
                <div className={styles.ctaWrapper} key={cta._key}>
                  <Cta {...cta}/>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default TextAndSideImage
